<h3 class="mat-dialog-title mb-2">
  Replacement Summary
  <button (click)="closeDialog()" type="button" class="float-end btn btn-sm">
    <mat-icon>close</mat-icon>
  </button>
</h3>
<div class="table-responsive">
  <table class="table table-hover">
    <thead>
      <tr>
        <th class="text-center">Status</th>
        <th class="">Date</th>
        <th>Drug Name</th>
        <th class="">Description</th>
        <th class="">#Refill</th>
        <th class="">Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let drug of drugs;let i=index"
        [ngClass]="{'replacedDrug': drug.Status == 'Replaced' && i == 0}"
      >
        <td class="text-center">{{drug?.Status}}</td>
        <td>{{drug?.CreatedDate | date:'MM/dd/yy'}}</td>
        <td>{{drug?.Name}}</td>
        <td matTooltip="{{drug?.Description}}" matTooltipPosition="left">
          {{ drug?.Description == ''|| drug?.Description ==
          null?'-':(drug?.Description?.length>25)? (drug?.Description |
          slice:0:25)+'..':(drug?.Description) }}
        </td>
        <td>
          {{(drug?.Refill == '' || drug?.Refill == null)?'-':drug?.Refill}}
        </td>
        <td>{{drug?.Remark}}</td>
      </tr>
    </tbody>
  </table>
</div>
